module.exports = __webpack_public_path__ + "static/media/brand-refresh-map-pin.bc5476aa.svg";